// extracted by mini-css-extract-plugin
export default {"controls":"NotesControls_controls__-mCq3","show_deleted":"NotesControls_show_deleted__7qE36"};